import { axiosInstance, requestConfig } from 'network/apis';

import { URL_BILLING } from 'utils/constants';

export const callBills = async (data) => {
    return await axiosInstance(requestConfig('get', URL_BILLING, '/bills', data));
};

export const callBillsDetail = async (id) => {
    return await axiosInstance(requestConfig('get', URL_BILLING, `/bills/${id}`));
};
